import React from 'react'
import { pathOr } from 'ramda'
import Line from '../../../packages/kiti/components/helpers/Line'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import Text, { Title } from '../../../packages/kiti/components/presentation/Text'
import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import Gallery from '../../../components/presentation/gallery/Gallery'
import { formatDate } from '@btime/helpers'

const fieldLabel = field => {
  switch (field) {
    case 'name':
      return 'Nome'
    case 'status':
      return 'Status'
    case 'description':
      return 'Descrição'
    case 'fieldValues':
      return 'Campo adicionais'
    case 'place':
      return 'Destino'
    case 'priority':
      return 'Prioridade'
    case 'user':
      return 'Responsável'
    case 'group':
      return 'Grupo'
    case 'documents':
      return 'Documentos'
    case 'asset':
      return 'Ativos'
    case 'scheduling':
      return 'Agendamento'
    case 'events':
      return 'Eventos'
    case 'address':
      return 'Endereço'
    default:
      return field
  }
}

const renderValue = (field, value) => {
  switch (field) {
    case 'description':
      return value
    case 'place':
      return formatter(value)
    case 'user':
      return formatter(value)
    case 'group':
      return formatter(value)
    case 'fieldValues':
      return formatFieldValues(value)
    case 'documents':
      return formatDocuments(value)
    case 'asset':
      return formatAsset(value)
    case 'scheduling':
      return formatScheduling(value)
    case 'events':
      return formatEvents(value)
    case 'address':
      return formatAddress(value)
    case 'status':
      return formatStatus(value)
    case 'name':
      return formatter(value)
    default:
      return '-'
  }
}

const formatStatus = value => {
  return value.label
}
const formatAddress = value => {
  return value.search
}

const formatEvents = value => {
  if (!value.length) return <></>

  const sortedEvents = [...value].sort((a, b) => {
    if (a.id > b.id) {
      return 1
    }
    return -1
  })

  return sortedEvents.map(event => {
    return (
      <div key={event.id}>
        <Separator weight={2} />
        {formatDate('DD/MM/YYYY HH:mm')(event.eventDate)}
        <Text>
          <b>{event.status.label}</b>
          {' por '}
          {event?.user?.name ? event?.user?.name : 'Anônimo'}
        </Text>
      </div>
    )
  })
}
const formatScheduling = value => {
  return formatDate('DD/MM/YYYY HH:mm')(value)
}

const formatAsset = value => {
  return formatter(value)
}

const formatDocuments = documents => {
  if (!documents?.length) return false

  return <Gallery items={documents} thumbHeight="3rem" colWidth="8rem" widthOnSm="20%" gap={0.4} />
}

const formatFieldValues = fieldValues => {
  if (!fieldValues?.length) return ''

  return fieldValues.map((fv, index) => {
    switch (fv.field.type) {
      case 'select':
        return <Text key={index}>{`${fv.field.name}: ${fv.value.name}`}</Text>
      case 'address':
        return <Text key={index}>{`${fv.field.name}: ${fv.value.search}`}</Text>
      case 'gallery':
        return (
          <>
            <Text key={index}>{`${fv.field.name}: `}</Text>
            <Gallery items={fv.value} thumbHeight="3rem" colWidth="8rem" widthOnSm="20%" gap={0.4} />
          </>
        )
      case 'text':
        return <Text key={index}>{`${fv.field.name}: ${fv.value}`}</Text>
      case 'email':
        return <Text key={index}>{`${fv.field.name}: ${fv.value}`}</Text>
      case 'number':
        return <Text key={index}>{`${fv.field.name}: ${fv.value}`}</Text>
      case 'datetime':
      case 'date':
        return <Text key={index}>{`${fv.field.name}: ${formatDate('DD/MM/YYYY HH:mm')(fv.value)}`}</Text>
      case 'checkbox':
        return <Text key={index}>{`${fv.field.name}: ${fv.value ? 'sim' : 'não'}`}</Text>
      default:
        return <Text key={index}>{`${fv.field.name}: ${JSON.stringify(fv.value)}`}</Text>
    }
  })
}
const formatter = value => {
  if (typeof value === 'object') {
    return value?.name
  }
  return value
}

const ComparePanel = ({ field, before, after }) => {
  const valueBefore = pathOr('', [field], before)
  const valueAfter = pathOr('', [field], after)

  return (
    <>
      <Line />
      <Separator weight={2} />
      <Title size="small" bold color="dark3">
        {fieldLabel(field)}
      </Title>
      <Separator weight={4} />
      <Grid paddingGutter={0.5}>
        <Col width="45%" wrapOn="sm">
          {renderValue(field, valueBefore)}
        </Col>
        <Col width="10%" wrapOn="sm" justify={'center'}>
          <Icon name="BsArrowRightShort" />
        </Col>
        <Col width="45%" wrapOn="sm">
          {renderValue(field, valueAfter)}
        </Col>
      </Grid>
    </>
  )
}

export default ComparePanel
